import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Icon, Input } from 'semantic-ui-react'
import CollaboratorActions from 'Redux/CollaboratorRedux'

class AddCollaborator extends Component {
  constructor () {
    super()
    this.state = {
      newCollaboratorEmail: ''
    }
  }

  handleChange = (e) => {
    this.setState({
      newCollaboratorEmail: e.target.value.toLowerCase().trim()
    })
  }

  validateEmail(email) {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  onAdd = () => {
    if (this.state.newCollaboratorEmail &&
        this.validateEmail(this.state.newCollaboratorEmail)) {
      this.props.collaboratorsAddRequest({
        email: this.state.newCollaboratorEmail,
        projectId: this.props.activeProject.id
      })
      this.setState({ newCollaboratorEmail: '' })
    }
  }

  render () {
    return (
      <Form>
        <Form.Field style={{display: 'none'}}>
          <Form.Button
            onClick={this.onAdd}>
              Submit
          </Form.Button>
        </Form.Field>
        <Form.Field>
          <Input
            loading={this.props.fetching}
            icon={
              <Icon
                name='plus'
                link
                onClick={this.onAdd}
              />}
            placeholder='Enter email'
            onChange={this.handleChange}
            value={this.state.newCollaboratorEmail}
          />
        </Form.Field>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  fetching: state.projects.updateFetching,
  error: state.projects.updateError,
  activeProject: state.selections.activeProject
})

const mapDispatchToProps = (dispatch) => ({
  collaboratorsAddRequest: (params) =>
    dispatch(CollaboratorActions.collaboratorsAddRequest(params))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddCollaborator)



// WEBPACK FOOTER //
// ./src/Components/AddCollaborator.js